module.exports = __webpack_public_path__ + "img/logo29.b1d7bd27.jpg";